export default {
    'terms.title': '使用條款',
} as Record<string, string>;
